var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5518_115620)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1272 3.64246C14.2521 3.76748 14.3223 3.93701 14.3223 4.11379C14.3223 4.29057 14.2521 4.4601 14.1272 4.58512L6.63248 12.0805C6.56438 12.1486 6.48353 12.2026 6.39453 12.2395C6.30554 12.2764 6.21015 12.2954 6.11382 12.2954C6.01749 12.2954 5.9221 12.2764 5.8331 12.2395C5.74411 12.2026 5.66325 12.1486 5.59515 12.0805L1.87115 8.35646C1.80921 8.29452 1.76008 8.22098 1.72656 8.14005C1.69303 8.05913 1.67578 7.97239 1.67578 7.88479C1.67578 7.79719 1.69303 7.71045 1.72656 7.62953C1.76008 7.5486 1.80921 7.47506 1.87115 7.41312C1.93309 7.35118 2.00663 7.30205 2.08755 7.26853C2.16848 7.23501 2.25522 7.21775 2.34282 7.21775C2.43042 7.21775 2.51715 7.23501 2.59808 7.26853C2.67901 7.30205 2.75255 7.35118 2.81449 7.41312L6.11449 10.7131L13.1838 3.64246C13.3088 3.51748 13.4784 3.44727 13.6552 3.44727C13.8319 3.44727 14.0021 3.51748 14.1272 3.64246Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5518_115620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.7447cdf93b6a1885c37a333b89aca1f3.svg";
export { ForwardRef as ReactComponent };